import { useMemo } from 'react'
import { useNavigate } from 'react-router-dom'
import { GetAllDoctors, DeleteDoctor } from '@/api/endpoints/Doctors'
import DeleteBtn from '@/components/tableDrawer/TableItems/components/tableActions/DeleteBtn'
import BaseBtn from '@/components/tableDrawer/TableItems/components/tableActions/BaseBtn'
import { ReportContent, ReportHeader, ReportSearch } from '@/components/tableDrawer'
import ScreenHeader from '@/components/ScreenHeader'
import ActionBtn from '@/components/ActionBtn'

const Doctor = () => {
    const navigate = useNavigate()

    const columns = useMemo(() => [
        {
            Header: 'doctor-name',
            accessor: 'name',
            canSearch: true,
        },
        {
            Header: 'specialty',
            accessor: 'specialty',
        },
        {
            Header: 'major-specialty',
            accessor: 'majorSpecialty',
        },
        {
            Header: 'email',
            accessor: 'email',
            canSearch: true,
        },
        {
            Header: 'phone',
            accessor: 'phoneNumber',
        },
        {
            Header: 'action',
            id: 'action',
            Cell: ({ row }) => (
                <>
                    <DeleteBtn api={DeleteDoctor} id={row.original.id} />
                    <BaseBtn onApply={() => handleNavigateToDoctorDetails(row.original?.id)} title="show-details" className="details-info" reqAction="canGet" icon={"mdi:eye"} />
                </>
            ),
        }], [])

    const handleNavigateToDoctorDetails = (id) =>
        navigate(`/panel/provider/doctors/details/${id}`)


    return (
        <>
            <ScreenHeader title="doctors-report">
                <ActionBtn onApply={() => navigate('/panel/provider/doctors/create')} title="add-doctor" className="accept-btn" icon={"mdi:plus"} />
            </ScreenHeader>
            <ReportContent tableAPI={GetAllDoctors} columns={columns}>
                <ReportHeader>
                    <ReportSearch />
                </ReportHeader>
            </ReportContent>
        </>
    )
}

export default Doctor